var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcesionarias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_59_7",
    "data-name": "Componente 59 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store_FILL0_wght300_GRAD0_opsz40",
    d: "M122.958-790h22.308a.942.942,0,0,1,.7.282.953.953,0,0,1,.281.7.935.935,0,0,1-.281.694.952.952,0,0,1-.7.277H122.958a.942.942,0,0,1-.7-.282.953.953,0,0,1-.281-.7.935.935,0,0,1,.281-.694A.952.952,0,0,1,122.958-790Zm.4,24.1a1.177,1.177,0,0,1-.866-.35,1.177,1.177,0,0,1-.35-.866v-8.45h-.828a1.152,1.152,0,0,1-.942-.455,1.153,1.153,0,0,1-.235-1.025l1.629-7.328a1.157,1.157,0,0,1,.434-.695,1.206,1.206,0,0,1,.758-.267h22.287a1.206,1.206,0,0,1,.758.267,1.157,1.157,0,0,1,.434.695l1.629,7.328a1.121,1.121,0,0,1-.232,1.027,1.17,1.17,0,0,1-.945.453h-.818v8.689a.942.942,0,0,1-.282.7.953.953,0,0,1-.7.281.935.935,0,0,1-.694-.281.952.952,0,0,1-.277-.7v-8.689h-7.549v8.45a1.177,1.177,0,0,1-.35.866,1.177,1.177,0,0,1-.866.35Zm.738-1.954h10.517v-7.713H124.094Zm-1.918-9.666h0Zm0,0h23.846l-1.319-5.863H123.495Z",
    transform: "translate(-118.102 793.949)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcesionarias);
export default __webpack_public_path__ + "static/media/concesionarias.16a1557756b5dd55e704675ff87398ff.svg";
export { ForwardRef as ReactComponent };